import React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import { Menu, Dropdown as AntDropDown } from 'antd';
import Button from '@ui-library/button';
import { DropDownProps } from 'antd/lib/dropdown';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import { MenuProps } from 'antd/lib/menu';
import styled from 'styled-components';

interface ItemProps extends MenuItemProps {
  label: string;
}
export interface DropDownMenuProps extends Partial<DropDownProps> {
  placeholder: string;
  items: ItemProps[];
  menuProps?: MenuProps;
}
const Dropdown = styled(AntDropDown)`
  border-radius: 6px !important;
  border: 1px solid #dedede !important;
`;

const CaretDown = styled(CaretDownOutlined)`
  margin-left: 6px;
  margin-top: 3px;
`;
const DropDownMenu = ({
  items,
  placeholder,
  menuProps = {},
  ...dropDownProps
}: DropDownMenuProps) => {
  const menu = (
    <Menu {...menuProps}>
      {items.map(({ label, ...restProps }) => (
        <Menu.Item {...restProps}>{label}</Menu.Item>
      ))}
    </Menu>
  );
  return (
    <Dropdown placement="bottomRight" {...dropDownProps} overlay={menu}>
      <Button>
        <>
          {placeholder} <CaretDown />
        </>
      </Button>
    </Dropdown>
  );
};

export default DropDownMenu;
